import React, { useContext, useEffect } from "react";
import PropTypes from "prop-types";
import {
  NavLink,
  Route,
  Routes,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import useTendering from "../../../hooks/useTendering";
import TenderingDetailContext from "../context";
import Quotations from "./Quotations";
import { Button } from "../../../components";
import Schedules from "./Schedules";
import Contract from "./Contract";
import PaymentTerms from "./PaymentTerms";
import BankGuarantee from "./BankGuarantee";
import TaxInvoices from "./TaxInvoices";

const assetsUri = import.meta.env.ASSETS_URI;

const Documents = () => {
  const { details, currentQuotation } = useContext(TenderingDetailContext);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {}, [location.pathname]);

  useEffect(() => {
    if (!details) {
      navigate(`/tenderings/${details._id}`);
      return;
    }

    if (currentQuotation && !currentQuotation.advancedPayment?.paid) {
      navigate(`/tenderings/${details._id}`);
      return;
    }
  }, [details, currentQuotation]);

  return (
    <div className="tendering-documents">
      <div className="tendering-documents__banner">
        <img
          className="tendering-documents__banner__image"
          src={`${assetsUri}/${
            details.images.cover.cropped ?? details.images.cover.original
          }`}
        />
      </div>
      <div className="tendering-documents__section">
        <ul className="tendering-documents__tabs">
          <NavLink
            to="quotations"
            className={({ isActive }) => {
              if (isActive)
                return "tendering-documents__tabs__tab tendering-documents__tabs__tab--active";

              return "tendering-documents__tabs__tab";
            }}
          >
            Quotations
          </NavLink>
          <NavLink
            to="schedules"
            className={({ isActive }) => {
              if (isActive)
                return "tendering-documents__tabs__tab tendering-documents__tabs__tab--active";

              return "tendering-documents__tabs__tab";
            }}
          >
            Master Schedules
          </NavLink>
          <NavLink
            to="contracts"
            className={({ isActive }) => {
              if (isActive)
                return "tendering-documents__tabs__tab tendering-documents__tabs__tab--active";

              return "tendering-documents__tabs__tab";
            }}
          >
            Contracts
          </NavLink>
          <NavLink
            to="payment-terms"
            className={({ isActive }) => {
              if (isActive)
                return "tendering-documents__tabs__tab tendering-documents__tabs__tab--active";

              return "tendering-documents__tabs__tab";
            }}
          >
            Payment Terms
          </NavLink>
          <NavLink
            to="bank-guarantee"
            className={({ isActive }) => {
              if (isActive)
                return "tendering-documents__tabs__tab tendering-documents__tabs__tab--active";

              return "tendering-documents__tabs__tab";
            }}
          >
            Bank Guarantee
          </NavLink>
          <NavLink
            to="tax-invoices"
            className={({ isActive }) => {
              if (isActive)
                return "tendering-documents__tabs__tab tendering-documents__tabs__tab--active";

              return "tendering-documents__tabs__tab";
            }}
          >
            Tax Invoices
          </NavLink>
        </ul>
        <Button
          label="Return to project detail"
          variant="secondary"
          size="small"
          onClick={() => navigate("../")}
        />
      </div>
      <div className="tendering-documents__content">
        <Routes>
          <Route path="quotations" element={<Quotations />} />
          <Route path="schedules" element={<Schedules />} />
          <Route path="contracts" element={<Contract />} />
          <Route path="payment-terms" element={<PaymentTerms />} />
          <Route path="bank-guarantee" element={<BankGuarantee />} />
          <Route path="tax-invoices" element={<TaxInvoices />} />
        </Routes>
      </div>
    </div>
  );
};

Documents.propTypes = {};

export default Documents;
